import React from 'react'
import servicesData from '../../../data/ServicesDetails.json'
import LazyLoad from 'react-lazyload'

const ServiceDetailsAbout = ({ serviceId }) => {
  const serviceID = parseInt(serviceId)
  const service = servicesData.servicesData.find(
    service => service.id === serviceID
  )

  if (!service) {
    return <div>Service not found</div>
  }

  return (
    <>
      {/* <div className='tp-service-page pt-140 pb-140'>
        <div className='container'>
          <div className='row pb-30'>
            <div className='col-lg-6 mb-30'>
              <div className='tp-sv-inner-img w-img'>
                <LazyLoad>
                  <img
                    src='/assets/img/service/service-details-1.webp'
                    alt=''
                  />
                </LazyLoad>
              </div>
            </div>
            <div className='col-lg-6 mb-30'>
              <div className='tp-sv-inner-img w-img'>
                <LazyLoad>
                  <img
                    src='/assets/img/service/service-details-2.webp'
                    alt=''
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='tp-sv__content'>
                <h3 className='tp-sv__title'>{service?.title}</h3>
                <h4 className='mb-40'>{service?.desc1}</h4>
                <h5>{service?.desc2}</h5>
                <div className='tp-border-line d-block'>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className='tp-cta-area'>
        <div className='container'>
          <div className='tp-cta-wrapper pt-20 pb-60'>
            <div className='row align-items-center justify-content-evenly'>
              <div className='col-lg-6'>
                <div className='tp-section-wrapper'>
                  <span className='tp-section-subtitle mb-25'>
                    Innovate. Scale. Succeed
                  </span>
                  <h2 className='tp-section-title mb-40'>{service?.title}</h2>
                  <p className='.tp-section-title-sm'>{service?.desc1}</p>
                  <p className='.tp-section-title-sm mt-20'>{service?.desc2}</p>
                </div>
              </div>
              <div className='col-lg-6 d-flex justify-content-end'>
                <LazyLoad>
                  <img
                    src='/assets/img/service/service-details-1.webp'
                    alt=''
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ServiceDetailsAbout
